import { TravailStubPage } from '../../../../components/parcours/TravailStubPage';
import { getTravailStub } from '../../../../config/travaux-particuliers';

export default function IsolationFenetresPage() {
  const travail = getTravailStub('isolation-fenetres');
  if (!travail) return null;
  return <TravailStubPage travail={travail} />;
}
